import { createApiMethod, type } from './utils/createApiMethod'

export interface SkillDetails {
  color: string
  id: string
  image_id: string
  is_current: boolean
  current_level: number
  name: string
  slug: string
}

export interface DomainProgress {
  id: string
  slug: string
  name: string
  num_points: number
  num_total_points: number
  num_available_topics: number
  num_completed_topics: number
}

export interface SkillProgress {
  current_level: number
  nodes: DomainProgress[]
  nodes_label: string
  points_to_next_level?: number
}

export interface SkillTopics {
  nodes_label: string
  nodes: SkillTopic[]
}

export interface SkillTopic {
  id: string
  slug: string
  name: string
  topics: SkillTopicDetails[]
  nodes_label?: string
  nodes?: SkillTopic[]
}

export interface SkillTopicDetails {
  id: number
  slug: string
  title: string
  fundamental: boolean
  image_id: string
  poster_image_id: string
  num_lectures: number
  has_chatbot_lecture?: boolean
  progress: SkillTopicDetailsProgress
}

export interface SkillTopicDetailsProgress {
  status: 'locked' | 'unlocked' | 'started' | 'viewed' | 'completed'
  num_completed_lectures: number
}

export interface SkillCurrent {
  color: string
  id: string
  image_id: string
  name: string
  progress: SkillProgress
  slug: string
  video_id: string
}

export interface SkillsList {
  skills: SkillDetails[]
}

export const skills = {
  assessmentStep: createApiMethod({
    method: 'GET',
    path: '/skills/assessment',
    response: type<{ num_completed_steps: number }>(),
  }),

  current: createApiMethod({
    method: 'GET',
    path: '/skills/current',
    response: type<SkillCurrent>(),
  }),

  update: createApiMethod({
    method: 'PUT',
    path: '/skills/current',
    data: type<{
      skill_id: string
    }>(),
  }),

  details: createApiMethod({
    method: 'GET',
    path: '/skills/:skillSlug',
    response: type<SkillDetails>(),
  }),

  list: createApiMethod({
    method: 'GET',
    path: '/skills',
    response: type<SkillsList>(),
  }),

  progressDetails: createApiMethod({
    method: 'GET',
    path: '/skills/:skillSlug/progress',
    response: type<SkillProgress>(),
  }),

  topics: createApiMethod({
    method: 'GET',
    path: '/skills/:skillSlug/topics',
    response: type<SkillTopics>(),
  }),
}
